import Login from './Login';
export default Login;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/Login/index.js